<template>
 <div>
     <p class="text-center sb-sub-header">Keep track of and share your medical information</p>
     <p class="pl-3">Here you can view all of the information on your own Personal Health Record – which you can fax to any healthcare provider or organization that needs it.</p>
     <p class="text-center p-2">
         <a href="#" type="button" @click="showModal = true" class="btn btn-primary btn-sb">Fax my personal health record</a>
     </p>
     <!-- Modal -->
     <div v-if="showModal">
         <transition name="modal">
             <div class="modal-mask">
                 <div class="modal-wrapper">
                     <div class="modal-dialog" role="document">
                         <div class="modal-content">
                             <div class="modal-header">
                                 <h5 class="modal-title">Send Personal Health Record</h5>
                                 <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                     <span aria-hidden="true" @click="showModal = false">&times;</span>
                                 </button>
                             </div>
                             <div class="modal-body" id="phr-form">
                                 <div class="form-group row" v-if="false">
                                     <label for="email" class="col-sm-4 col-form-label">Way to send</label>
                                     <div class="col-sm-8">
                                         <select v-model="sendData.type" id="type" name="type" class="form-control required">
                                             <option>Please Select</option>
                                             <option v-for="t in types" :value="t">{{t}}</option>
                                         </select>
                                     </div>
                                 </div>
                                 <div class="form-group">

                                 </div>
                                 <div class="form-group row" v-if="sendData.type=='email'">
                                     <label for="email" class="col-sm-4 col-form-label">Email</label>
                                     <div class="col-sm-8">
                                         <input type="text" class="form-control required" id="email" name="email" v-model="sendData.email">
                                     </div>
                                 </div>
                                 <div class="form-group row" v-if="sendData.type=='fax'">
                                     <label for="email" class="col-sm-4 col-form-label">Fax Number</label>
                                     <div class="col-sm-8">
                                         <input type="text" class="form-control required" id="faxNumber" name="faxNumber" v-model="sendData.faxNumber">
                                     </div>
                                 </div>
                             </div>
                             <div class="modal-footer">
                                 <button type="button" class="btn btn-secondary" @click="showModal = false">Close</button>
                                 <button v-if="(sendData.type=='email' && sendData.email!='') || (sendData.type=='fax' && sendData.faxNumber!='')" type="button" class="btn btn-primary" @click="send">Send</button>
                             </div>
                         </div>
                     </div>
                 </div>
             </div>
         </transition>
     </div>
 </div>
</template>

<script>
    export default {
        props:[
        ],
        mounted() {

        },
        created: function() {

        },
        data(){
            return {
                route: '/api/sendPHR',
                showModal:false,
                sendData:{
                    email:'',
                    faxNumber:'',
                    type:'fax'
                },
                types:[
                    'email',
                    'fax'
                ]
            }
        },
        methods:{

            send(){
                this.$http.post(this.route, this.sendData)
                    .then(function(response) {
                        $('.has-error').removeClass('has-error')
                        $('.help-block').remove()
                        this.showModal=false;
                    }, (response) => {
                        this._handleErrors(response.data, '#phr-form')
                    })
            },
            _handleErrors: function(items, selector)
            {
                $('.has-error').removeClass('has-error')
                $('.help-block').remove()

                for (var error in items['errors']) {
                    if (items['errors'].hasOwnProperty(error)) {
                        var text = error;
                        var parts = text.split('.');
                        var name = parts.pop();
                        var el = $(selector + ' [name="'+name+'"]')
                        el.closest('.form-group').addClass('has-error')
                        $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                    }
                }
            }
        }

    }
</script>
